export const FONT_WEIGHT_CONSTANTS = {
    fonts: ['Light', 'Regular', 'Medium'],
};
